import React, { useState } from "react";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import Landing from "../Landing/Landing";
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import toparrow from "../../image/newImg/toparrow.png";
import SideBar from "../SideBar/SideBar";
import "./Content.css";
import "./Results.css";
import { Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
// import s1 from "../../image/r10/s1.jpg";
// import s2 from "../../image/r10/s2.jpg";
// import s3 from "../../image/r10/s3.jpg";
// import s4 from "../../image/r10/s4.jpg";
// import s5 from "../../image/r10/s5.jpg";
// import s6 from "../../image/r10/s6.jpg";
// import s7 from "../../image/r10/s7.jpg";
// import s8 from "../../image/r10/s8.jpg";
// import s9 from "../../image/r10/s9.jpg";
// import s10 from "../../image/r10/s10.jpg";
// import s11 from "../../image/r10/s11.jpg";
// import s12 from "../../image/r10/s12.jpg";
// import s13 from "../../image/r10/s13.jpg";
// import s14 from "../../image/r10/s14.jpg";
// import s15 from "../../image/r10/s15.jpg";
// import s16 from "../../image/r10/s16.jpg";
// import s17 from "../../image/r10/s17.jpg";
// import s18 from "../../image/r10/s18.jpg";
// import s19 from "../../image/r10/s19.jpg";
// import s20 from "../../image/r10/s20.jpg";
// import s21 from "../../image/r10/s21.jpg";
import s22 from "../../image/r10/s22.png";
import s23 from "../../image/r10/s23.png";
import s24 from "../../image/r10/s24.png";
import s25 from "../../image/r10/s25.png";

// import s22 from "../../image/r12/s22.jpg";
// import s23 from "../../image/r12/s23.jpg";
// import s24 from "../../image/r12/s24.jpg";
// import s25 from "../../image/r12/s25.jpg";
// import s26 from "../../image/r12/s26.png";
// import s27 from "../../image/r12/s27.png";
// import s28 from "../../image/r12/s28.png";
// import s29 from "../../image/r12/s29.png";
// import s30 from "../../image/r12/s30.png";
// import s31 from "../../image/r12/s31.jpg";
// import s32 from "../../image/r12/s32.png";
// import s33 from "../../image/r12/s33.png";
// import s34 from "../../image/r12/s34.jpg";
// import s35 from "../../image/r12/s35.png";
// import s36 from "../../image/r12/s36.jpg";
// import s37 from "../../image/r12/s37.png";
// import s38 from "../../image/r12/s38.png";
// import s39 from "../../image/r12/s39.png";
import s40 from "../../image/r12/s40.png";
import s41 from "../../image/r12/s41.png";
import s42 from "../../image/r12/s42.png";
import NewNavbar from "../NavBar/NewNavbar";

const x10th = require("../../excel/faridabad10.xlsx");
const x12th = require("../../excel/faridabad12.xlsx");

function Results(props) {
  const canonicalUrl = `https://hermanngmeinerschoolfaridabad.org/results`;
  const { cover, sidebar_data, side_heading, side_sub_heading } = props;
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, steIsShow] = useState(false);
  const handleScroll = (e) => {
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
    if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };
  const handleClick = () => {
    steIsShow(!isShow);
    console.log(isShow);
  };

  return (
    <div className="content_main" onScroll={handleScroll}>
      <Helmet>
        <title>Academic Excellence | Results of HGS Faridabad</title>
        <meta name='description' content='View the academic achievements and CBSE results of HGS Faridabad. Celebrating student success and excellence in education every year.' />
        <meta name='Keywords' content='school results Faridabad, CBSE school results, academic achievements HG, student success Faridabad, HGS results' />
        <link rel='canonical' href='https://hermanngmeinerschoolfaridabad.org/results' />
      </Helmet>

      <NewNavbar handleClick={handleClick} />
      {/* <Navbar isScrolled={isScrolled} handleClick={handleClick} /> */}
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      <Landing video={false} cover={cover} />
      <div className="contentmain_cont">
        <div style={{ width: "min-content" }}>
          <SideBar
            sidebar_data={sidebar_data}
            side_heading={side_heading}
            side_sub_heading={side_sub_heading}
          />
          <Contact />
        </div>
        <div>
          <div className={`f-2 f-500 mb-3`} style={{ color: "#1FDC00ED" }}>
            <img
              className="admissions__image"
              src={toparrow}
              style={{ marginRight: "1rem" }}
            />{" "}
            Results
          </div>
          <Col>
            <div className="row">
              <div className="col-lg-5">
                <div className="result-btn mt-2">
                  <a href={x10th}>
                    <button className="tenth_result">
                      VIEW 10 YEARS RESULT ANALYSIS (X)
                    </button>
                  </a>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="result-btn mt-2">
                  <a href={x12th}>
                    <button className="tenth_result">
                      VIEW 10 YEARS’ RESULT ANALYSIS (XII)
                    </button>
                  </a>
                </div>
              </div>
            </div>
            <Row className="resultsrow">
              <div style={{ fontSize: "1.2rem", marginTop: "1.5rem" }}>
                <b>Toppers: X</b>
              </div>
              {/* <Row>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s1} />
                    <div className="details">
                      <p className="sname">Bhoomi Hans</p>
                      <p className="marks">95.8%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s2} />
                    <div className="details">
                      <p className="sname">Jamil Ahmed Sayyed</p>
                      <p className="marks">95%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s3} />
                    <div className="details">
                      <p className="sname">Nikitaa Shukla</p>
                      <p className="marks">94.2%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s4} />
                    <div className="details">
                      <p className="sname">Eshaa Shukla</p>
                      <p className="marks">94.2%</p>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s5} />
                    <div className="details">
                      <p className="sname">Arju</p>
                      <p className="marks">93.8%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s6} />
                    <div className="details">
                      <p className="sname">Kashish</p>
                      <p className="marks">93.8%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s7} />
                    <div className="details">
                      <p className="sname">Gautam Jha</p>
                      <p className="marks">93.2%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s8} />
                    <div className="details">
                      <p className="sname">Saumya Srivastava</p>
                      <p className="marks">92.6%</p>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s9} />
                    <div className="details">
                      <p className="sname">Yash Kumar Jha</p>
                      <p className="marks">92%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s10} />
                    <div className="details">
                      <p className="sname">Harsh Maurya</p>
                      <p className="marks">91.8%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s11} />
                    <div className="details">
                      <p className="sname">Nandini Shukla</p>
                      <p className="marks">91.6%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s12} />
                    <div className="details">
                      <p className="sname">Mayank Kumar</p>
                      <p className="marks">91.4%</p>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s13} />
                    <div className="details">
                      <p className="sname">Shristi Singh</p>
                      <p className="marks">91%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s14} />
                    <div className="details">
                      <p className="sname">Aparna Sharma</p>
                      <p className="marks">89.8%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s15} />
                    <div className="details">
                      <p className="sname">Ayush Sharma</p>
                      <p className="marks">89.4%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s16} />
                    <div className="details">
                      <p className="sname">Naman Rana</p>
                      <p className="marks">89.2%</p>
                    </div>
                  </div>
                </Col>
              </Row> */}
              {/* <Row>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s17} />
                    <div className="details">
                      <p className="sname">Neha Yadav</p>
                      <p className="marks">87.8%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s18} />
                    <div className="details">
                      <p className="sname">Akshat Bajpai</p>
                      <p className="marks">87.2%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s19} />
                    <div className="details">
                      <p className="sname">Mansi</p>
                      <p className="marks">86.8%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s20} />
                    <div className="details">
                      <p className="sname">Satyam Jawla</p>
                      <p className="marks">86%</p>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s21} />
                    <div className="details">
                      <p className="sname">Lalit Punetha</p>
                      <p className="marks">85.8%</p>
                    </div>
                  </div>
                </Col>
              </Row> */}

              <Row className="pe-0">
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s22} />
                    <div className="details">
                      <p className="sname">Riddhishree Nayak</p>
                      <p className="marks">95.4%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s23} />
                    <div className="details">
                      <p className="sname">Madhav Sarawat</p>
                      <p className="marks">91.8%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s24} />
                    <div className="details">
                      <p className="sname">Mustafa</p>
                      <p className="marks">91.4%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle pe-0">
                  <div className="resultcard">
                    <img className="studentimg" src={s25} />
                    <div className="details">
                      <p className="sname">Kajal</p>
                      <p className="marks">90.2%</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Row>
            <Row className="resultsrow">
              <div style={{ fontSize: "1.2rem", marginTop: "2rem" }}>
                <b>Toppers: XII</b>
              </div>
              {/* <Row>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s22} />
                    <div className="details">
                      <p className="sname">Purva Sharma</p>
                      <p className="marks">96.2%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s23} />
                    <div className="details">
                      <p className="sname">Muskan Hans</p>
                      <p className="marks">95.2%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s24} />
                    <div className="details">
                      <p className="sname">Lalit Kumar</p>
                      <p className="marks">94.2%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s25} />
                    <div className="details">
                      <p className="sname">Nitin Kumar</p>
                      <p className="marks">93.8%</p>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s26} />
                    <div className="details">
                      <p className="sname">Muskan Nimodia</p>
                      <p className="marks">93.4%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s27} />
                    <div className="details">
                      <p className="sname">Soni</p>
                      <p className="marks">92.6%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s28} />
                    <div className="details">
                      <p className="sname">Sanjay Kumar</p>
                      <p className="marks">92.2%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s29} />
                    <div className="details">
                      <p className="sname">Anannya Malviya</p>
                      <p className="marks">92%</p>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s30} />
                    <div className="details">
                      <p className="sname">Mayank Bhadana</p>
                      <p className="marks">92%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s31} />
                    <div className="details">
                      <p className="sname">Arpita Adak</p>
                      <p className="marks">91.6%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s32} />
                    <div className="details">
                      <p className="sname">Anuj Shrivastava</p>
                      <p className="marks">91.4%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s33} />
                    <div className="details">
                      <p className="sname">Deepak Kumar Jha</p>
                      <p className="marks">91.2%</p>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s34} />
                    <div className="details">
                      <p className="sname">Aditya Maurya</p>
                      <p className="marks">90.8%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s35} />
                    <div className="details">
                      <p className="sname">Jai Juggal</p>
                      <p className="marks">88.6%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s36} />
                    <div className="details">
                      <p className="sname">Vaibhav Namdev</p>
                      <p className="marks">87.8%</p>
                    </div>
                  </div>
                </Col>
                <Col className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s37} />
                    <div className="details">
                      <p className="sname">Sapna</p>
                      <p className="marks">87.8%</p>
                    </div>
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-center align-items-center gap-4 result_last">
                <div className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s38} />
                    <div className="details">
                      <p className="sname">Dishakha Saini</p>
                      <p className="marks">84.8%</p>
                    </div>
                  </div>
                </div>
                <div className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s39} />
                    <div className="details">
                      <p className="sname">Yash</p>
                      <p className="marks">84.6%</p>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="d-flex justify-content-start align-items-center gap-4 result_last">
                <div className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s40} />
                    <div className="details">
                      <p className="sname">Jamil Ahamad</p>
                      <p className="marks">95.4%</p>
                    </div>
                  </div>
                </div>
                <div className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s41} />
                    <div className="details">
                      <p className="sname">Kashish</p>
                      <p className="marks">90%</p>
                    </div>
                  </div>
                </div>
                <div className="middle">
                  <div className="resultcard">
                    <img className="studentimg" src={s42} />
                    <div className="details">
                      <p className="sname">Mansi</p>
                      <p className="marks">88.4%</p>
                    </div>
                  </div>
                </div>
              </div>
            </Row>
          </Col>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Results;
